import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const FacilityIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 29 30">
        <path d="m14.5 0-14.5 10.47v19.53h29l-2e-3 -19.53zm-2.496 10h5v5.5h5.5v5h-5.5v5.5h-5v-5.5h-5.5v-5h5.5z" />
    </SvgIcon>
);
